import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit"
import { withTranslation } from "react-i18next"
import { Link, useHistory } from "react-router-dom"
import { Col, Modal, Row, Spinner, UncontrolledTooltip } from "reactstrap"
import { removeRole, searchRoles } from "services/users/calls"

const { SearchBar } = Search

const List = props => {
  const { reRender } = props

  const [modalRedefinePass, setModalRedefinePass] = useState(false)
  const [showConfirm, setShowConfirm] = useState(false)
  const [confirm, setConfirm] = useState({})

  const [isLoading, handleLoading] = useState(true)
  const [roles, setRoles] = useState([])
  const [rolesTotal, setRolesTotal] = useState(0)
  const [limit] = useState(30)
  const [offset, setOffset] = useState(0)
  const [query, setQuery] = useState("")
  const [currentPage, setCurrentPage] = useState(1)
  const [pages, setPages] = useState([])
  const [hasError, setError] = useState(false)
  let history = useHistory()

  // TODO:
  // Mudar editar usuário abrir um modal

  const initPageOptions = {
    sizePerPage: limit,
    totalSize: 0,
    custom: true,
    showTotal: true,
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
    prePageText: "Anterior",
    nextPageText: "Próximo",
    paginationTotalRenderer: (from, to, size) => {
      return (
        <div className="d-inline">
          <span className="react-bootstrap-table-pagination-total">
            Registros Retornados: {size}
          </span>
        </div>
      )
    },
  }

  const [pageOptions, setPageOptions] = useState(initPageOptions)

  const defaultSorted = [
    {
      dataField: "name",
      order: "asc",
    },
  ]

  const selectRow = {
    mode: "checkbox",
    hideSelectColumn: true,
  }

  const columns = [
    {
      dataField: "name",
      text: "Nome",
      sort: false,
      headerAttrs: { colSpan: 2 },
      formatter: (cellContent, row) => cellContent || 0,
    },

    {
      dataField: "options",
      isDummyField: true,
      text: "",
      headerStyle: {
        display: "none",
      },
      align: "right",
      formatter: (cellContent, row) => {
        return (
          <ul className="list-unstyled hstack gap-1 mb-0 flex-row-reverse">
            <li>
              <Link
                to="#"
                className="btn btn-sm btn-soft-danger"
                onClick={() => {
                  setConfirm({
                    title: "Confirmação",
                    body: (
                      <div>
                        <p>Essa ação é irreversivel!</p>
                        <p>
                          Por favor, confirme se tem certeza que deseja apagar
                          este perfil?
                        </p>
                      </div>
                    ),
                    onConfirm: async () => {
                      onDeleteProfile(row.id)
                    },
                  })
                  setShowConfirm(true)
                }}
              >
                <i
                  className="mdi mdi-delete-forever"
                  id={`deletetooltip${row.id}`}
                />
                <UncontrolledTooltip
                  placement="top"
                  target={`deletetooltip${row.id}`}
                >
                  Excluir
                </UncontrolledTooltip>
              </Link>
            </li>
            <li>
              <Link
                to="#"
                className="btn btn-sm btn-soft-info"
                onClick={() => {
                  history.push(`/configuracoes/acessos/perfis/${row.id}`)
                  props.setNav(2)
                }}
              >
                <i
                  className="mdi mdi-pencil-outline"
                  id={`edittooltip${row.id}`}
                />
                <UncontrolledTooltip
                  placement="top"
                  target={`edittooltip${row.id}`}
                >
                  Editar
                </UncontrolledTooltip>
              </Link>
            </li>
          </ul>
        )
      },
    },
  ]

  const fetchRoles = async () => {
    try {
      const { payload } = await searchRoles(query, offset, limit)
      const roles = payload.roles
      const total = payload.roles.length
      setRoles(roles)
      setRolesTotal(total)
      const pages = Math.ceil(total / limit)
      setPages(pages)
    } catch (error) {
      setError(error)
    } finally {
      handleLoading(false)
    }
  }

  const onDeleteProfile = async id => {
    try {
      handleLoading(true)
      const { payload } = await removeRole(id)
      fetchRoles()
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    handleLoading(true)
    setRoles([])
    fetchRoles()
  }, [query, offset, limit, reRender])

  return (
    <React.Fragment>
      {!isLoading && (
        <div>
          {roles.length > 0 && (
            <PaginationProvider
              pagination={paginationFactory(pageOptions)}
              keyField="name"
              columns={columns}
              data={roles}
            >
              {({ paginationTableProps }) => (
                <ToolkitProvider
                  keyField="name"
                  columns={columns}
                  columnToggle
                  data={roles}
                  search
                >
                  {toolkitProps => (
                    <React.Fragment>
                      <Row>
                        <SearchBar
                          {...toolkitProps.searchProps}
                          placeholder="Pesquisar"
                        />
                        <hr />
                      </Row>

                      <Row>
                        <Col xl="12">
                          <div className="table-responsive">
                            <BootstrapTable
                              keyField={"name"}
                              responsive
                              bordered={true}
                              striped={true}
                              defaultSorted={defaultSorted}
                              selectRow={selectRow}
                              classes={"table align-middle table-nowrap"}
                              headerWrapperClasses={"thead-light"}
                              {...toolkitProps.baseProps}
                              {...paginationTableProps}
                            />
                          </div>
                        </Col>
                      </Row>
                    </React.Fragment>
                  )}
                </ToolkitProvider>
              )}
            </PaginationProvider>
          )}
          {roles.length === 0 && (
            <div style={{ textAlign: "center" }}>
              <h5>Nenhum dado encontrado.</h5>
            </div>
          )}
        </div>
      )}
      {isLoading && (
        <div className="mt-3" style={{ textAlign: "center" }}>
          <Spinner className="ms-2" color="primary" />
        </div>
      )}
      <Modal
        isOpen={showConfirm}
        toggle={() => {
          setShowConfirm(!showConfirm)
        }}
        centered
        onClosed={() => {
          //   fetchUsers()
        }}
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0" id="myModalLabel">
            <p>{confirm?.title}</p>
          </h5>
          <button
            type="button"
            onClick={() => {
              setShowConfirm(false)
              {
                confirm
              }
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">{confirm?.body}</div>
        <div className="modal-footer">
          <button
            type="button"
            onClick={() => {
              setShowConfirm(false)
            }}
            className="btn btn-secondary"
            data-dismiss="modal"
          >
            {props.t("Cancelar")}
          </button>
          <button
            type="button"
            onClick={() => {
              setShowConfirm(false)
              confirm?.onConfirm()
            }}
            className="btn btn-primary"
            data-dismiss="modal"
          >
            {props.t("Confirmar")}
          </button>
        </div>
      </Modal>
    </React.Fragment>
  )
}

List.propTypes = {
  t: PropTypes.any,
  reRender: PropTypes.bool,
  setUserId: PropTypes.func,
  setNav: PropTypes.func,
}

export default withTranslation()(List)
